// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/Inspection.css
// module id = 2707
// module chunks = 2